import React, {useEffect, useState} from 'react';
import {Grid, IconButton, Tooltip, Typography} from "@mui/material";
import {PRIMARY_COLOR, SECONDARY_COLOR, WHITE} from "../../../constants/Colors";
import {ChartContext} from "../../../contexts/ChartContext";
import USDService from "../../../services/USDService";
import EditIcon from "@mui/icons-material/Edit";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import CustomTextField from "../../../general_components/CustomTextField";
import LoadingButton from "../../../general_components/LoadingButton";
import Dialog from "@mui/material/Dialog";
import ConstantsService from "../../../services/ConstantsService";
import {ConstantsContext} from "../../../contexts/ConstantsContext";

function Kibor({kiborRate, update}) {

    const [value, setValue] = useState(0);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        setValue(kiborRate)
    }, [kiborRate]);

    const onSubmit = async (e) => {
        e.preventDefault();
        ConstantsService.editConstants({field: 'kiborRate', value: value}).then(response => {
            if(response.data.success){
                setOpen(false);
                update(value);
            }
        }).catch(() => alert("Something went wrong!"));
    }

    return (
        <Grid item xs={12} sm={4} md={3}>
            <div style={{borderRadius: 20, backgroundColor: SECONDARY_COLOR, padding: 20, position: 'relative'}}>
                <Typography variant={'body2'} style={{color: '#fff'}}>
                    Kibor Rate
                </Typography>
                <Typography variant={'h4'} color={'primary'}>
                    {kiborRate}
                </Typography>
                <Tooltip title={"Edit Kibor Rate"}>
                    <IconButton
                        onClick={() => {
                            setOpen(true)
                        }}
                        sx={{zIndex: 1000,
                            position: 'absolute',
                            top: 14, right: 10
                        }}
                    >
                        <EditIcon style={{fontSize: 18}} color={'primary'}/>
                    </IconButton>
                </Tooltip>
            </div>
            <Dialog open={open} onClose={() => setOpen(false)} maxWidth='sm'>
                <DialogTitle sx={{display: 'flex', alignItems: 'center'}}>
                    <Typography variant={'body1'} style={{color: PRIMARY_COLOR, fontWeight: '600', flexGrow: 1}}>
                        Edit Kibor Rate
                    </Typography>
                </DialogTitle>
                <DialogContent style={{width: 350, paddingTop: 0}}>
                    <form onSubmit={onSubmit}>
                        <CustomTextField
                            autoFocus={true}
                            required
                            disabled={false}
                            value={value}
                            onValueChange={setValue}
                            labelName={'Kibor Rate'}
                            style={{marginBottom: 25}}
                        />
                        <LoadingButton
                            type={'submit'} loading={false} text={'Update'}
                            sx={{color: WHITE}}
                        />
                    </form>
                </DialogContent>
            </Dialog>
        </Grid>
    );
}

export default Kibor;